// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CreatorItem-module__font-s-10___KDWhi {
  font-size: 10px !important;
}

.CreatorItem-module__font-s-12___Ty0qp {
  font-size: 12px !important;
}

.CreatorItem-module__font-s-13___oomAN {
  font-size: 13px !important;
}

.CreatorItem-module__font-s-14___yhojN {
  font-size: 14px !important;
}

.CreatorItem-module__font-s-15___RPA8T {
  font-size: 15px !important;
}

.CreatorItem-module__font-s-16___qjDbr {
  font-size: 16px !important;
}

.CreatorItem-module__font-s-18___xrdZL {
  font-size: 18px !important;
}

.CreatorItem-module__font-s-20___XxbZg {
  font-size: 20px !important;
}

.CreatorItem-module__font-s-22___JOWOe {
  font-size: 22px !important;
}

.CreatorItem-module__font-s-28___EapQU {
  font-size: 28px !important;
}

.CreatorItem-module__font-w-400___kt5vD {
  font-weight: 400 !important;
}

.CreatorItem-module__font-w-500___GBbHz {
  font-weight: 500 !important;
}

.CreatorItem-module__font-w-600___Thep8 {
  font-weight: 600 !important;
}

.CreatorItem-module__font-w-700___Geuhg {
  font-weight: 700 !important;
}

.CreatorItem-module__p-5___sZxmL {
  padding: 5px !important;
}

.CreatorItem-module__p-12___iBzg6 {
  padding: 12px !important;
}

.CreatorItem-module__p-16___Hne1j {
  padding: 16px !important;
}

.CreatorItem-module__p-30___CU_yD {
  padding: 30px !important;
}

.CreatorItem-module__p-b-0___vtURt {
  padding-bottom: 0 !important;
}

.CreatorItem-module__p-b-5___g9CwB {
  padding-bottom: 5px !important;
}

.CreatorItem-module__p-b-10___RrsmB {
  padding-bottom: 10px !important;
}

.CreatorItem-module__p-b-12___yJlca {
  padding-bottom: 12px !important;
}

.CreatorItem-module__p-b-16___Cw0JL {
  padding-bottom: 16px !important;
}

.CreatorItem-module__p-b-18___hwZtM {
  padding-bottom: 18px !important;
}

.CreatorItem-module__p-b-20___a7Ru1 {
  padding-bottom: 20px !important;
}

.CreatorItem-module__p-b-25___NwJn5 {
  padding-bottom: 25px !important;
}

.CreatorItem-module__p-b-30___RnEo3 {
  padding-bottom: 30px !important;
}

.CreatorItem-module__p-b-50___rUamF {
  padding-bottom: 50px !important;
}

.CreatorItem-module__p-t-0___pNNBE {
  padding-top: 0 !important;
}

.CreatorItem-module__p-t-12___MhreE {
  padding-top: 12px !important;
}

.CreatorItem-module__p-t-16___jM1y6 {
  padding-top: 16px !important;
}

.CreatorItem-module__p-t-18___qE9ov {
  padding-top: 18px !important;
}

.CreatorItem-module__p-t-20___isoIo {
  padding-top: 20px !important;
}

.CreatorItem-module__p-t-30___nnHbN {
  padding-top: 30px !important;
}

.CreatorItem-module__p-t-40___wpOBJ {
  padding-top: 40px !important;
}

.CreatorItem-module__p-t-50___Bqgys {
  padding-top: 50px !important;
}

.CreatorItem-module__p-l-20___N7qDj {
  padding-left: 20px !important;
}

.CreatorItem-module__p-l-30___Pk1iQ {
  padding-left: 30px !important;
}

.CreatorItem-module__p-l-40___qdG_w {
  padding-left: 40px !important;
}

.CreatorItem-module__p-r-16___HqUtj {
  padding-right: 16px !important;
}

.CreatorItem-module__p-r-20___lLsi7 {
  padding-right: 20px !important;
}

.CreatorItem-module__p-r-30___vA7OU {
  padding-right: 30px !important;
}

.CreatorItem-module__p-r-50___f03Tg {
  padding-right: 50px !important;
}

.CreatorItem-module__p-r-60___Pd4_0 {
  padding-right: 60px !important;
}

.CreatorItem-module__m-b-1___SbhXk {
  margin-bottom: 1px !important;
}

.CreatorItem-module__m-b-2___wcbP5 {
  margin-bottom: 2px !important;
}

.CreatorItem-module__m-b-6___vNku9 {
  margin-bottom: 6px !important;
}

.CreatorItem-module__m-b-8___HXfW2 {
  margin-bottom: 8px !important;
}

.CreatorItem-module__m-b-10___wy0yb {
  margin-bottom: 10px !important;
}

.CreatorItem-module__m-b-14____1gP1 {
  margin-bottom: 14px !important;
}

.CreatorItem-module__m-b-16___VC80x {
  margin-bottom: 16px !important;
}

.CreatorItem-module__m-b-20___QAvRt {
  margin-bottom: 20px !important;
}

.CreatorItem-module__m-b-22___pvsfg {
  margin-bottom: 22px !important;
}

.CreatorItem-module__m-b-24___y1oC1 {
  margin-bottom: 24px !important;
}

.CreatorItem-module__m-b-30___tTisN {
  margin-bottom: 30px !important;
}

.CreatorItem-module__m-b-32___F6fWD {
  margin-bottom: 32px !important;
}

.CreatorItem-module__m-b-40___pu73e {
  margin-bottom: 40px !important;
}

.CreatorItem-module__m-t-2___lkDOY {
  margin-top: 2px !important;
}

.CreatorItem-module__m-t-3___SzUuf {
  margin-top: 3px !important;
}

.CreatorItem-module__m-t-4___E1cI4 {
  margin-top: 4px !important;
}

.CreatorItem-module__m-t-5___V73s3 {
  margin-top: 5px !important;
}

.CreatorItem-module__m-t-8___usGnd {
  margin-top: 8px !important;
}

.CreatorItem-module__m-t-10___swtlc {
  margin-top: 10px !important;
}

.CreatorItem-module__m-t-15___pkQre {
  margin-top: 15px !important;
}

.CreatorItem-module__m-t-16___l0yUN {
  margin-top: 16px !important;
}

.CreatorItem-module__m-t-20___hAFx0 {
  margin-top: 20px !important;
}

.CreatorItem-module__m-t-22___MdePr {
  margin-top: 22px !important;
}

.CreatorItem-module__m-t-30___MRkrU {
  margin-top: 30px !important;
}

.CreatorItem-module__m-t-32___JRyw2 {
  margin-top: 32px !important;
}

.CreatorItem-module__m-l-auto___W36rT {
  margin-left: auto !important;
}

.CreatorItem-module__m-l-4___NClwv {
  margin-left: 4px !important;
}

.CreatorItem-module__m-l-5___iV8Ok {
  margin-left: 5px !important;
}

.CreatorItem-module__m-l-6___yElfR {
  margin-left: 6px !important;
}

.CreatorItem-module__m-l-8___Deoks {
  margin-left: 8px !important;
}

.CreatorItem-module__m-l-10___zUj3b {
  margin-left: 10px !important;
}

.CreatorItem-module__m-l-16___nbCiN {
  margin-left: 16px !important;
}

.CreatorItem-module__m-l-20___UeZnQ {
  margin-left: 20px !important;
}

.CreatorItem-module__m-l-24___PjSpj {
  margin-left: 24px !important;
}

.CreatorItem-module__m-l-30____XwES {
  margin-left: 30px !important;
}

.CreatorItem-module__m-l-35___P_38O {
  margin-left: 35px !important;
}

.CreatorItem-module__m-l-40___Wu9_q {
  margin-left: 40px !important;
}

.CreatorItem-module__m-r-8___P1kfQ {
  margin-right: 8px !important;
}

.CreatorItem-module__m-r-10___zVwfa {
  margin-right: 10px !important;
}

.CreatorItem-module__m-r-16___XNKfB {
  margin-right: 16px !important;
}

.CreatorItem-module__m-r-20___KP0cH {
  margin-right: 20px !important;
}

.CreatorItem-module__m-r-24___XfHv7 {
  margin-right: 24px !important;
}

.CreatorItem-module__m-r-30___QqhSm {
  margin-right: 30px !important;
}

.CreatorItem-module__m-r-40___qk4OM {
  margin-right: 40px !important;
}

.CreatorItem-module__border-r-3___aB9Hf {
  border-radius: 3px !important;
}

.CreatorItem-module__border-r-4___htJXr {
  border-radius: 4px !important;
}

.CreatorItem-module__border-r-6___WBbPA {
  border-radius: 6px !important;
}

.CreatorItem-module__border-r-10___YNBf1 {
  border-radius: 10px !important;
}

.CreatorItem-module__border-r-12____BVV2 {
  border-radius: 12px !important;
}

.CreatorItem-module__border-r-16___pgGSh {
  border-radius: 16px !important;
}

.CreatorItem-module__border-r-50___lRwrV {
  border-radius: 50% !important;
}

.CreatorItem-module__primary-border___DGflH {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.CreatorItem-module__primary-border-b___lpzcj {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.CreatorItem-module__primary-border-t___DjSWz {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.CreatorItem-module__primary-border-l___bTDvQ {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.CreatorItem-module__primary-border-r___fPMLW {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.CreatorItem-module__secondary-border___wxPsx {
  border: 1px solid #637768;
}

.CreatorItem-module__secondary-border-b___Z8joI {
  border-bottom: 1px solid #637768;
}

.CreatorItem-module__secondary-border-t___q2wWB {
  border-top: 1px solid #637768;
}

.CreatorItem-module__secondary-border-l___AQ_tp {
  border-left: 1px solid #637768;
}

.CreatorItem-module__secondary-border-r___a8DpE {
  border-right: 1px solid #637768;
}

.CreatorItem-module__gap-0___RAsiF {
  gap: 0 !important;
}

.CreatorItem-module__gap-2___Urtra {
  gap: 2px !important;
}

.CreatorItem-module__gap-4___Txa3K {
  gap: 4px !important;
}

.CreatorItem-module__gap-5___Zm3BR {
  gap: 5px !important;
}

.CreatorItem-module__gap-6___vXYOd {
  gap: 6px !important;
}

.CreatorItem-module__gap-8___cy4AI {
  gap: 8px !important;
}

.CreatorItem-module__gap-10___rIWnU {
  gap: 10px !important;
}

.CreatorItem-module__gap-12___eT5_A {
  gap: 12px !important;
}

.CreatorItem-module__gap-14___RdDfn {
  gap: 14px !important;
}

.CreatorItem-module__gap-16___TNaZk {
  gap: 16px !important;
}

.CreatorItem-module__gap-18___cuM3b {
  gap: 18px !important;
}

.CreatorItem-module__gap-20___CmHdX {
  gap: 20px !important;
}

.CreatorItem-module__gap-24___weIiL {
  gap: 24px !important;
}

.CreatorItem-module__gap-26___RlU1t {
  gap: 26px !important;
}

.CreatorItem-module__gap-30___IuhRS {
  gap: 30px !important;
}

.CreatorItem-module__gap-32___jTTDu {
  gap: 32px !important;
}

.CreatorItem-module__gap-40___DJLXm {
  gap: 40px !important;
}

.CreatorItem-module__gap-50___L_4K9 {
  gap: 50px !important;
}

.CreatorItem-module__flex-1___OFXeK {
  flex: 1;
}

.CreatorItem-module__flex-none___YuEsv {
  flex: none !important;
}

.CreatorItem-module__flex-column___wmvie {
  display: flex;
  flex-direction: column !important;
}

.CreatorItem-module__flex-row___kX0gn {
  display: flex;
  flex-direction: row !important;
}

.CreatorItem-module__vertically-centered___GG_0O {
  display: flex;
  align-items: center !important;
}

.CreatorItem-module__horizontally-centered___yMhQx {
  display: flex;
  justify-content: center !important;
}

.CreatorItem-module__horizontally-end___STNif {
  display: flex;
  justify-content: end !important;
}

.CreatorItem-module__vertically-start___Kx8v4 {
  display: flex;
  align-items: start !important;
}

.CreatorItem-module__space-between___YyFpM {
  display: flex;
  justify-content: space-between !important;
}

.CreatorItem-module__flex-wrap___k9NdG {
  flex-wrap: wrap !important;
}

.CreatorItem-module__height-100___BHkDO {
  height: 100%;
}

.CreatorItem-module__width-50___axC5J {
  width: 50% !important;
}

.CreatorItem-module__width-100___IGGpu {
  width: 100%;
}

.CreatorItem-module__cursor-pointer___Pd7Sx {
  cursor: pointer;
}

.CreatorItem-module__cursor-not-allowed___asUHU {
  cursor: not-allowed !important;
}

.CreatorItem-module__absolute-centered___QmN97 {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.CreatorItem-module__absolute___Sxf4X {
  position: absolute;
}

.CreatorItem-module__relative___pbPBr {
  position: relative;
}

.CreatorItem-module__fixed___hVvRX {
  position: fixed;
}

.CreatorItem-module__visible___iYnLA {
  opacity: 1;
}

.CreatorItem-module__invisible___Jz9jW {
  opacity: 0;
}

.CreatorItem-module__col-90___BWNSP {
  width: 90% !important;
}

.CreatorItem-module__col-auto___iP5TD {
  width: auto !important;
}

.CreatorItem-module__medical-tabs___DnMQG {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.CreatorItem-module__medical-table-new___Jsufa {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.CreatorItem-module__medical-table-new___Jsufa:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.CreatorItem-module__medical-table-new___Jsufa::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.CreatorItem-module__medical-table-new___Jsufa::-webkit-scrollbar-track {
  display: none;
}
.CreatorItem-module__medical-table-new___Jsufa.CreatorItem-module__no-pagination___QmhdF {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.CreatorItem-module__medical-table-new___Jsufa.CreatorItem-module__no-pagination___QmhdF:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.CreatorItem-module__medical-table-new___Jsufa.CreatorItem-module__no-pagination___QmhdF::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.CreatorItem-module__medical-table-new___Jsufa.CreatorItem-module__no-pagination___QmhdF::-webkit-scrollbar-track {
  display: none;
}

.CreatorItem-module__medical-table-empty___G046M {
  padding: 14px 40px !important;
}

.CreatorItem-module__icon-btn___M1jvO {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.CreatorItem-module__search-icon___LXpD3 {
  width: 24px;
  height: 24px;
  align-self: center;
}

.CreatorItem-module__disable-select___sqYtP {
  user-select: none;
}

.CreatorItem-module__break-word___azz8C {
  word-break: break-word;
}

.CreatorItem-module__popup-clear-btn___a0yus {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.CreatorItem-module__scroll-m-b-20___GdjbA {
  scroll-margin-bottom: 20px;
}

.CreatorItem-module__container___Qqybi {
  flex: 1;
}
.CreatorItem-module__container___Qqybi .CreatorItem-module__title___RGuGW {
  height: 20px;
  font-family: var(--font-family);
  font-weight: 400;
  color: #375844;
  line-height: 150%;
}
.CreatorItem-module__container___Qqybi .CreatorItem-module__subtitle___lxpoK {
  font-family: var(--font-family);
  font-weight: 400;
  color: #859989;
  line-height: 15px;
  letter-spacing: -0.011em;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/components/table/CreatorItem/CreatorItem.module.scss","webpack://./../common/src/styles/global/_mixins.scss","webpack://./../common/src/styles/global/_fonts.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,OAAA;AA8pBF;AA5pBE;EACE,YAAA;EEoBF,+BApBO;EAqBP,gBAFmD;EFjBjD,cAAA;EACA,iBAAA;AA+pBJ;AA5pBE;EEcA,+BApBO;EAqBP,gBAFmD;EFXjD,cAAA;EACA,iBAAA;EACA,wBAAA;AA+pBJ","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.container {\n  flex: 1;\n\n  .title {\n    height: 20px;\n    @include get-font($roboto);\n    color: get-color(greenNew, dark);\n    line-height: 150%;\n  }\n\n  .subtitle {\n    @include get-font($roboto);\n    color: get-color(greenNew, medium);\n    line-height: 15px;\n    letter-spacing: -0.011em;\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n","@use 'sass:map';\n@use 'sass:meta';\n@use 'sizes';\n\n// font families\n// TODO: rename this variable\n$roboto: var(--font-family);\n\n// functions\n@function get-font-size($font-size: null) {\n  // check font size exists\n  @if (map.has-key(sizes.$font-sizes, $font-size)) {\n    $value: map.get(sizes.$font-sizes, $font-size);\n    @if meta.type-of($value) == number {\n      // return font size\n      @return $value;\n    }\n\n    @return null;\n  }\n\n  @return null;\n}\n\n// mixins\n@mixin get-font($font-family: $roboto, $font-weight: 400, $font-size: null) {\n  font-family: $font-family;\n  font-weight: $font-weight;\n  font-size: get-font-size($font-size);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `CreatorItem-module__font-s-10___KDWhi`,
	"fontS12": `CreatorItem-module__font-s-12___Ty0qp`,
	"fontS13": `CreatorItem-module__font-s-13___oomAN`,
	"fontS14": `CreatorItem-module__font-s-14___yhojN`,
	"fontS15": `CreatorItem-module__font-s-15___RPA8T`,
	"fontS16": `CreatorItem-module__font-s-16___qjDbr`,
	"fontS18": `CreatorItem-module__font-s-18___xrdZL`,
	"fontS20": `CreatorItem-module__font-s-20___XxbZg`,
	"fontS22": `CreatorItem-module__font-s-22___JOWOe`,
	"fontS28": `CreatorItem-module__font-s-28___EapQU`,
	"fontW400": `CreatorItem-module__font-w-400___kt5vD`,
	"fontW500": `CreatorItem-module__font-w-500___GBbHz`,
	"fontW600": `CreatorItem-module__font-w-600___Thep8`,
	"fontW700": `CreatorItem-module__font-w-700___Geuhg`,
	"p5": `CreatorItem-module__p-5___sZxmL`,
	"p12": `CreatorItem-module__p-12___iBzg6`,
	"p16": `CreatorItem-module__p-16___Hne1j`,
	"p30": `CreatorItem-module__p-30___CU_yD`,
	"pB0": `CreatorItem-module__p-b-0___vtURt`,
	"pB5": `CreatorItem-module__p-b-5___g9CwB`,
	"pB10": `CreatorItem-module__p-b-10___RrsmB`,
	"pB12": `CreatorItem-module__p-b-12___yJlca`,
	"pB16": `CreatorItem-module__p-b-16___Cw0JL`,
	"pB18": `CreatorItem-module__p-b-18___hwZtM`,
	"pB20": `CreatorItem-module__p-b-20___a7Ru1`,
	"pB25": `CreatorItem-module__p-b-25___NwJn5`,
	"pB30": `CreatorItem-module__p-b-30___RnEo3`,
	"pB50": `CreatorItem-module__p-b-50___rUamF`,
	"pT0": `CreatorItem-module__p-t-0___pNNBE`,
	"pT12": `CreatorItem-module__p-t-12___MhreE`,
	"pT16": `CreatorItem-module__p-t-16___jM1y6`,
	"pT18": `CreatorItem-module__p-t-18___qE9ov`,
	"pT20": `CreatorItem-module__p-t-20___isoIo`,
	"pT30": `CreatorItem-module__p-t-30___nnHbN`,
	"pT40": `CreatorItem-module__p-t-40___wpOBJ`,
	"pT50": `CreatorItem-module__p-t-50___Bqgys`,
	"pL20": `CreatorItem-module__p-l-20___N7qDj`,
	"pL30": `CreatorItem-module__p-l-30___Pk1iQ`,
	"pL40": `CreatorItem-module__p-l-40___qdG_w`,
	"pR16": `CreatorItem-module__p-r-16___HqUtj`,
	"pR20": `CreatorItem-module__p-r-20___lLsi7`,
	"pR30": `CreatorItem-module__p-r-30___vA7OU`,
	"pR50": `CreatorItem-module__p-r-50___f03Tg`,
	"pR60": `CreatorItem-module__p-r-60___Pd4_0`,
	"mB1": `CreatorItem-module__m-b-1___SbhXk`,
	"mB2": `CreatorItem-module__m-b-2___wcbP5`,
	"mB6": `CreatorItem-module__m-b-6___vNku9`,
	"mB8": `CreatorItem-module__m-b-8___HXfW2`,
	"mB10": `CreatorItem-module__m-b-10___wy0yb`,
	"mB14": `CreatorItem-module__m-b-14____1gP1`,
	"mB16": `CreatorItem-module__m-b-16___VC80x`,
	"mB20": `CreatorItem-module__m-b-20___QAvRt`,
	"mB22": `CreatorItem-module__m-b-22___pvsfg`,
	"mB24": `CreatorItem-module__m-b-24___y1oC1`,
	"mB30": `CreatorItem-module__m-b-30___tTisN`,
	"mB32": `CreatorItem-module__m-b-32___F6fWD`,
	"mB40": `CreatorItem-module__m-b-40___pu73e`,
	"mT2": `CreatorItem-module__m-t-2___lkDOY`,
	"mT3": `CreatorItem-module__m-t-3___SzUuf`,
	"mT4": `CreatorItem-module__m-t-4___E1cI4`,
	"mT5": `CreatorItem-module__m-t-5___V73s3`,
	"mT8": `CreatorItem-module__m-t-8___usGnd`,
	"mT10": `CreatorItem-module__m-t-10___swtlc`,
	"mT15": `CreatorItem-module__m-t-15___pkQre`,
	"mT16": `CreatorItem-module__m-t-16___l0yUN`,
	"mT20": `CreatorItem-module__m-t-20___hAFx0`,
	"mT22": `CreatorItem-module__m-t-22___MdePr`,
	"mT30": `CreatorItem-module__m-t-30___MRkrU`,
	"mT32": `CreatorItem-module__m-t-32___JRyw2`,
	"mLAuto": `CreatorItem-module__m-l-auto___W36rT`,
	"mL4": `CreatorItem-module__m-l-4___NClwv`,
	"mL5": `CreatorItem-module__m-l-5___iV8Ok`,
	"mL6": `CreatorItem-module__m-l-6___yElfR`,
	"mL8": `CreatorItem-module__m-l-8___Deoks`,
	"mL10": `CreatorItem-module__m-l-10___zUj3b`,
	"mL16": `CreatorItem-module__m-l-16___nbCiN`,
	"mL20": `CreatorItem-module__m-l-20___UeZnQ`,
	"mL24": `CreatorItem-module__m-l-24___PjSpj`,
	"mL30": `CreatorItem-module__m-l-30____XwES`,
	"mL35": `CreatorItem-module__m-l-35___P_38O`,
	"mL40": `CreatorItem-module__m-l-40___Wu9_q`,
	"mR8": `CreatorItem-module__m-r-8___P1kfQ`,
	"mR10": `CreatorItem-module__m-r-10___zVwfa`,
	"mR16": `CreatorItem-module__m-r-16___XNKfB`,
	"mR20": `CreatorItem-module__m-r-20___KP0cH`,
	"mR24": `CreatorItem-module__m-r-24___XfHv7`,
	"mR30": `CreatorItem-module__m-r-30___QqhSm`,
	"mR40": `CreatorItem-module__m-r-40___qk4OM`,
	"borderR3": `CreatorItem-module__border-r-3___aB9Hf`,
	"borderR4": `CreatorItem-module__border-r-4___htJXr`,
	"borderR6": `CreatorItem-module__border-r-6___WBbPA`,
	"borderR10": `CreatorItem-module__border-r-10___YNBf1`,
	"borderR12": `CreatorItem-module__border-r-12____BVV2`,
	"borderR16": `CreatorItem-module__border-r-16___pgGSh`,
	"borderR50": `CreatorItem-module__border-r-50___lRwrV`,
	"primaryBorder": `CreatorItem-module__primary-border___DGflH`,
	"primaryBorderB": `CreatorItem-module__primary-border-b___lpzcj`,
	"primaryBorderT": `CreatorItem-module__primary-border-t___DjSWz`,
	"primaryBorderL": `CreatorItem-module__primary-border-l___bTDvQ`,
	"primaryBorderR": `CreatorItem-module__primary-border-r___fPMLW`,
	"secondaryBorder": `CreatorItem-module__secondary-border___wxPsx`,
	"secondaryBorderB": `CreatorItem-module__secondary-border-b___Z8joI`,
	"secondaryBorderT": `CreatorItem-module__secondary-border-t___q2wWB`,
	"secondaryBorderL": `CreatorItem-module__secondary-border-l___AQ_tp`,
	"secondaryBorderR": `CreatorItem-module__secondary-border-r___a8DpE`,
	"gap0": `CreatorItem-module__gap-0___RAsiF`,
	"gap2": `CreatorItem-module__gap-2___Urtra`,
	"gap4": `CreatorItem-module__gap-4___Txa3K`,
	"gap5": `CreatorItem-module__gap-5___Zm3BR`,
	"gap6": `CreatorItem-module__gap-6___vXYOd`,
	"gap8": `CreatorItem-module__gap-8___cy4AI`,
	"gap10": `CreatorItem-module__gap-10___rIWnU`,
	"gap12": `CreatorItem-module__gap-12___eT5_A`,
	"gap14": `CreatorItem-module__gap-14___RdDfn`,
	"gap16": `CreatorItem-module__gap-16___TNaZk`,
	"gap18": `CreatorItem-module__gap-18___cuM3b`,
	"gap20": `CreatorItem-module__gap-20___CmHdX`,
	"gap24": `CreatorItem-module__gap-24___weIiL`,
	"gap26": `CreatorItem-module__gap-26___RlU1t`,
	"gap30": `CreatorItem-module__gap-30___IuhRS`,
	"gap32": `CreatorItem-module__gap-32___jTTDu`,
	"gap40": `CreatorItem-module__gap-40___DJLXm`,
	"gap50": `CreatorItem-module__gap-50___L_4K9`,
	"flex1": `CreatorItem-module__flex-1___OFXeK`,
	"flexNone": `CreatorItem-module__flex-none___YuEsv`,
	"flexColumn": `CreatorItem-module__flex-column___wmvie`,
	"flexRow": `CreatorItem-module__flex-row___kX0gn`,
	"verticallyCentered": `CreatorItem-module__vertically-centered___GG_0O`,
	"horizontallyCentered": `CreatorItem-module__horizontally-centered___yMhQx`,
	"horizontallyEnd": `CreatorItem-module__horizontally-end___STNif`,
	"verticallyStart": `CreatorItem-module__vertically-start___Kx8v4`,
	"spaceBetween": `CreatorItem-module__space-between___YyFpM`,
	"flexWrap": `CreatorItem-module__flex-wrap___k9NdG`,
	"height100": `CreatorItem-module__height-100___BHkDO`,
	"width50": `CreatorItem-module__width-50___axC5J`,
	"width100": `CreatorItem-module__width-100___IGGpu`,
	"cursorPointer": `CreatorItem-module__cursor-pointer___Pd7Sx`,
	"cursorNotAllowed": `CreatorItem-module__cursor-not-allowed___asUHU`,
	"absoluteCentered": `CreatorItem-module__absolute-centered___QmN97`,
	"absolute": `CreatorItem-module__absolute___Sxf4X`,
	"relative": `CreatorItem-module__relative___pbPBr`,
	"fixed": `CreatorItem-module__fixed___hVvRX`,
	"visible": `CreatorItem-module__visible___iYnLA`,
	"invisible": `CreatorItem-module__invisible___Jz9jW`,
	"col90": `CreatorItem-module__col-90___BWNSP`,
	"colAuto": `CreatorItem-module__col-auto___iP5TD`,
	"medicalTabs": `CreatorItem-module__medical-tabs___DnMQG`,
	"medicalTableNew": `CreatorItem-module__medical-table-new___Jsufa`,
	"noPagination": `CreatorItem-module__no-pagination___QmhdF`,
	"medicalTableEmpty": `CreatorItem-module__medical-table-empty___G046M`,
	"iconBtn": `CreatorItem-module__icon-btn___M1jvO`,
	"searchIcon": `CreatorItem-module__search-icon___LXpD3`,
	"disableSelect": `CreatorItem-module__disable-select___sqYtP`,
	"breakWord": `CreatorItem-module__break-word___azz8C`,
	"popupClearBtn": `CreatorItem-module__popup-clear-btn___a0yus`,
	"scrollMB20": `CreatorItem-module__scroll-m-b-20___GdjbA`,
	"container": `CreatorItem-module__container___Qqybi`,
	"title": `CreatorItem-module__title___RGuGW`,
	"subtitle": `CreatorItem-module__subtitle___lxpoK`
};
module.exports = ___CSS_LOADER_EXPORT___;
